import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 应用
export const APP = 'app';
export const APP_BASE = 'app-base';
export const APP_VIEW = 'app-view';
export const APP_SERVICE = 'app-service'; // 业务对象
export const APP_ICON = 'app-icon';
export const APP_BUILD = 'app-build';
export const APP_TEMPLATE = 'templates';
export const APP_LOGS = 'app-logs';
export const APP_LOG_DETAIL = 'app-logs-detail';
export const TENANT_UPGRADE = 'tenant-upgrade';
export const DEPLOYMENT_MANAGE = 'deployment-manage';

/**
 * 资源管理
 * 囊括了 组件外层页面 和 私有化部署（原名为部署配置管理）
 */

export const RESOURCE_MANAGEMENT = 'resource-management';
export const APP_ARRANGEMENT = 'app-arrangement';
// 组件外层
export const COMPONENT = 'component';
export const COMPONENT_LIST = 'component-list';
export const COMPONENT_PACKAGE = 'component-package';
export const COMPONENT_GROUP = 'component-group';
// 组价详情
export const COMPONENT_DETAIL = 'component-detail';
export const COMPONENT_PACKAGE_DETAIL = 'package-detail';
export const COMPONENT_PACKAGE_ITEM_DETAIL = 'package-item-detail';
export const COMPONENT_GROUP_DETAIL = 'group-detail';

// 小程序管理
export const WINXIN_PLATFORM = 'weixin-platform';
export const PLATFORM_MANAGEMENT = 'platform-management';
export const SUBMIT = 'submit';

export const MESSAGE = 'MESSAGE';

// 修改 path 时，记得修改一下下面的正则
export const PATH__PACKAGE_APP =    '/app/:appId/:version/:env(test|beta|prod)/package';
// 匹配生成 APP 的所有页面
export const REG__PACKAGE_APP = /^\/app\/((?:[^/]+?))\/((?:[^/]+?))\/((?:test|beta|prod))\/package/i;

// 应用版本分页数据的存储字段名
// 没有找到比较合适的位置放这个
export const KEY__APP_VERSION = 'app-version-query';

const routes = [
    {
        path: '/',
        name: 'root',
        meta: {
            requireLogin: true
        },
        redirect: 'login',
        component: () => import('src/pages/dev/main/index'),
        children: [
            // 产品
            {
                name: 'product',
                path: 'product',
                component: () => import('src/pages/dev/product/index')
            },
            {
                name: 'product-detail',
                path: 'product/:productId',
                component: () => import('src/pages/dev/product/detail/index')
            },
            // 应用
            {
                name: APP,
                path: 'app/:appId',
                component: () => import('src/pages/dev/app/index'),
                redirect: 'app/:appId/build',
                children: [
                    // 基本信息
                    {
                        name: APP_BASE,
                        path: 'base',
                        component: () => import('src/pages/dev/app/base/index')
                    },
                    // 业务对象管理
                    {
                        name: APP_SERVICE,
                        path: 'service',
                        component: {
                            template: '<router-view></router-view>'
                        },
                        redirect: { name: 'bizEntry' },
                        children: [
                            {
                                name: 'bizEntry',
                                path: 'bizEntry',
                                component: () => import('src/pages/dev/app/service/biz-entry') // 业务对象管理入口分发页
                            },
                            // 新业务对象管理
                            {
                                name: 'objectList',
                                path: 'objectList',
                                component: () => import('src/pages/dev/app/new-object/index')
                            },
                            {
                                name: 'objectDetail',
                                path: 'objectDetail/:objectId',
                                component: () => import('src/pages/dev/app/new-object/detail')
                            },
                            // 新服务管理
                            {
                                name: 'serviceList',
                                path: 'serviceList',
                                component: () => import('src/pages/dev/app/new-service/index')
                            },
                            {
                                name: 'oldServiceList',
                                path: 'oldServiceList',
                                component: () => import('src/pages/dev/app/service/index')
                            },
                            {
                                name: 'serciceDetail',
                                path: 'serciceDetail/:id',
                                component: () => import('src/pages/dev/app/service/detail')
                            }
                        ]
                    },
                    
                    // 应用构建
                    {
                        path: 'build',
                        component: {
                            template: '<router-view></router-view>'
                        },
                        children: [
                            {
                                name: APP_BUILD,
                                path: '',
                                component: () => import('src/pages/dev/app/build/index')
                            },
                            {
                                name: APP_TEMPLATE,
                                path: 'templates/:version',
                                component: () => import(
                                    'src/pages/dev/app/build/app-templates/index'
                                )
                            },
                            {
                                name: DEPLOYMENT_MANAGE,
                                path: 'env/:env',
                                component: () => import(
                                    'src/pages/dev/app/build/deployment-manage/index'
                                )
                            }
                        ]
                    },
                    // 应用日志
                    {
                        path: 'log',
                        props: true,
                        component: {
                            template: '<router-view></router-view>'
                        },
                        children: [
                            {
                                name: APP_LOGS,
                                path: '',
                                props: true,
                                component: () => import('src/pages/dev/app/logs/index')
                            },
                            {
                                name: APP_LOG_DETAIL,
                                path: 'detail/:logId',
                                props: true,
                                component: () => import('src/pages/dev/app/logs/detail')
                            }
                        ]
                    },
                    // 应用图标
                    {
                        name: APP_ICON,
                        path: 'icon',
                        component: () => import('src/pages/dev/app/icon/index')
                    },
                    // 小程序管理
                    {
                        path: 'weixin',
                        redirect: { name: WINXIN_PLATFORM },
                        component: {
                            template: '<router-view></router-view>'
                        },
                        children: [
                            {
                                name: WINXIN_PLATFORM,
                                path: 'platform',
                                component: () => import('src/pages/dev/app/platform/index')
                            },
                            {
                                name: PLATFORM_MANAGEMENT,
                                path: 'management',
                                component: () => import(
                                    'src/pages/dev/app/platform/management'
                                )
                            },
                            {
                                name: SUBMIT,
                                path: 'submit',
                                component: () => import('src/pages/dev/app/platform/vertify')
                            }
                        ]
                    },
                    // 租户升级
                    {
                        path:
                            'env/:env/tenantId/:tenantId/tenantCode/:tenantCode',
                        name: TENANT_UPGRADE,
                        component: () => import('src/pages/dev/app/tenant')
                    }
                ]
            },
            // 应用打包
            {
                name: 'package',
                path: PATH__PACKAGE_APP,
                props: true,
                component: () => import('src/pages/dev/package/index'),
                children: [
                    {
                        name: 'package-style',
                        path: 'style',
                        component: () => import('src/pages/dev/package/style/index')
                    },
                    {
                        name: 'package-config',
                        path: 'config',
                        component: () => import('src/pages/dev/package/config/index')
                    },
                    {
                        name: 'package-cred',
                        path: 'cred',
                        component: () => import('src/pages/dev/package/cred/index')
                    },
                    {
                        name: 'package-engine',
                        path: 'engine',
                        component: () => import('src/pages/dev/package/engine/index')
                    },
                    {
                        name: 'package-hooks',
                        path: 'hooks',
                        component: () => import('src/pages/dev/package/hooks/index')
                    },
                    {
                        name: 'package-plugin',
                        path: 'plugin',
                        component: () => import('src/pages/dev/package/plugin/index')
                    },
                    {
                        name: 'package-build',
                        path: 'build',
                        component: () => import('src/pages/dev/package/build/index')
                    }
                ]
            },
            // 详情
            {
                name: COMPONENT_DETAIL,
                path: 'component-detail/:id',
                component: () => import('src/pages/dev/components/component-detail/index')
            },
            {
                name: COMPONENT_PACKAGE_DETAIL,
                path: 'package-detail/:id',
                component: () => import('src/pages/dev/components/package-detail/index')
            },
            {
                name: COMPONENT_PACKAGE_ITEM_DETAIL,
                path: 'package-item-detail/:id',
                component: () => import('src/pages/dev/components/component-detail/index')
            },
            {
                name: COMPONENT_GROUP_DETAIL,
                path: 'group-detail/:id',
                component: () => import('src/pages/dev/components/group-detail/index')
            },
            // 资源管理
            {
                name: RESOURCE_MANAGEMENT,
                path: 'resource-management',
                component: () => import('src/pages/dev/resource-management'),
                redirect: { name: COMPONENT },
                children: [
                    // 组件
                    {
                        name: COMPONENT,
                        path: 'component',
                        component: () => import('src/pages/dev/components/index'),
                        redirect: 'component/list',
                        children: [
                            {
                                name: COMPONENT_LIST,
                                path: 'list',
                                component: () => import(
                                    'src/pages/dev/components/list/index'
                                ),
                                meta: {
                                    title: '组件列表'
                                }
                            },
                            {
                                name: COMPONENT_PACKAGE,
                                path: 'package',
                                component: () => import(
                                    'src/pages/dev/components/package/index'
                                ),
                                meta: {
                                    title: '组件包列表'
                                }
                            },
                            {
                                name: COMPONENT_GROUP,
                                path: 'group',
                                component: () => import(
                                    'src/pages/dev/components/group/index'
                                ),
                                meta: {
                                    title: '组件分组'
                                }
                            }
                        ]
                    },
                    // 部署配置管理
                    {
                        name: APP_ARRANGEMENT,
                        path: 'arrangement',
                        component: () => import(
                            'src/pages/dev/resource-management/feature/arrangement'
                        )
                    }
                ]
            },
            // 用户
            {
                name: 'user',
                path: 'user',
                component: () => import('src/pages/dev/user/index')
            },
            // 消息
            {
                name: MESSAGE,
                path: 'message',
                component: () => import('src/pages/dev/message/index')
            },
            // 个人中心
            {
                name: 'profile',
                path: 'profile',
                component: () => import('src/pages/dev/profile/index')
            },
            // 联系我们
            {
                name: 'contact',
                path: '/contact',
                component: () => import('src/pages/dev/contact/index')
            }
        ]
    },
    // 登录
    {
        name: 'login',
        path: '/login',
        meta: {
            isCustom: true
        },
        component: () => import('src/pages/dev/login/index')
    },
    {
        name: '403',
        path: '/403.html',
        component: () => import('src/pages/dev/403/index')
    },
    {
        name: '404',
        path: '/404.html',
        component: () => import('src/pages/dev/404/index')
    },
    {
        path: '*',
        redirect: '/product'
    }
];
export default new Router({ routes });
